import APP_LOGO from './assets/logo.svg'

export default {
    APP_LOGO,
}